import { Divider, Typography } from 'antd'
import React from 'react'
import BinInward from '../../../components/Wash/BinInward/BinInward'
import GSMInward from '../../../components/GSuperMarket/GSMInwatd/GSMInward'
import BinBlukOutward from '../../../components/DispatchCentre/BlukOutward/Bin/BinBlukOutward'

const BinBlukOutwardPage = ({userData}) => {
  return (
    <>
      <BinBlukOutward userData={userData} />
    </>
  )
}

export default BinBlukOutwardPage